<template>
  <div
    :class="[ open ? 'sponsorship__content--visible' : null ]"
    class="sponsorship__content"
  >
    <div class="sponsorship__mainText">
      <Wysiwyg>
        <div v-editable="resource.columns.mainText" />
      </Wysiwyg>
    </div>
    <Wysiwyg
      v-if="resource.columns.subText"
      :class="[ resource.columns.large ? 'titled-markdown__text--large' : null ]"
      class="sponsorship__subText"
    >
      <div v-editable="resource.columns.subText" />
    </Wysiwyg>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'

export default {
  components: {
    Wysiwyg
  },
  mixins: [editable],
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>
